import Header from '@/components/Header';
import Hero from '@/components/Hero';
import Benefits from '@/components/Benefits';
import About from '@/components/About';
import DirectorySearch from '@/components/DirectorySearch';
import CTATiles from '@/components/CTATiles';
import FAQ from '@/components/FAQ';
import Footer from '@/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-[#f5f2f0]">
      <Header />
      <Hero />
      <Benefits />
      <About />
      <DirectorySearch />
      <CTATiles />
      <FAQ />
      <Footer />
    </div>
  );
}
